(() => {
  const queue = window.CCMBrowseQueue || [];
  queue.splice(0).forEach((config) => {
  const root = document.querySelector('[data-ccm-browse-section="' + config.sectionId + '"]');
  if (!root || root.dataset.ccmBrowseReady === 'true') return;
  root.dataset.ccmBrowseReady = 'true';
  const products = config.products;

  const state = {
    brand:'All',
    body:'All',
    powertrain:'All',
    drive:'All',
    buyer:'All',
    rangeMin:'All',
    priceStatus:'All',
    feature:'All',
    budget:Number(root.querySelector('[data-role="budget"]')?.value || config.budgetCeiling),
    search:'',
    sort:'featured'
  };
  const grid = root.querySelector('[data-role="grid"]');
  const cards = grid ? [...grid.querySelectorAll('.ccm-card')] : [];
  const count = root.querySelector('[data-role="count"]');
  const empty = root.querySelector('[data-role="empty"]');
  const search = root.querySelector('[data-role="search"]');
  const mobileSearch = root.querySelector('[data-role="mobile-search"]');
  const budget = root.querySelector('[data-role="budget"]');
  const budgetLabel = root.querySelector('[data-role="budget-label"]');
  const sort = root.querySelector('[data-role="sort"]');
  const ACTIVE_CURRENCY = config.currency;
  const formatMarketCurrency = (value) => {
    const amount = Number(value || 0);
    try {
      return new Intl.NumberFormat('en-US', {
        style:'currency',
        currency:ACTIVE_CURRENCY,
        currencyDisplay:'code',
        minimumFractionDigits:0,
        maximumFractionDigits:0
      }).format(amount);
    } catch (_) {
      return ACTIVE_CURRENCY + ' ' + Math.round(amount).toLocaleString('en-US');
    }
  };
  const formatBrowseAmount = (value) => Math.round(Number(value || 0)).toLocaleString('en-US');
  const pricedValues = products.map((product) => Number(product.price || 0)).filter((value) => value > 0);
  const budgetStep = ['BHD','KWD','OMR'].includes(ACTIVE_CURRENCY) ? 1000 : (ACTIVE_CURRENCY === 'USD' ? 5000 : 10000);
  const marketBudgetMax = pricedValues.length
    ? Math.max(budgetStep, Math.ceil(Math.max(...pricedValues) / budgetStep) * budgetStep)
    : Number(budget?.max || config.budgetCeiling);
  if (budget) {
    budget.min = 0;
    budget.max = marketBudgetMax;
    budget.step = budgetStep;
    budget.value = marketBudgetMax;
  }
  state.budget = marketBudgetMax;
  if (budgetLabel) budgetLabel.textContent = formatMarketCurrency(marketBudgetMax);
  const brandFilter = root.querySelector('[data-role="brand-filter"]');
  const resetButtons = root.querySelectorAll('[data-role="reset"]');
  const filter = root.querySelector('[data-role="filter-panel"]');
  const filterToggle = root.querySelector('[data-role="filter-toggle"]');
  const filterToggleLabel = root.querySelector('[data-role="filter-toggle-label"]');
  const filterCloseButtons = root.querySelectorAll('[data-role="filter-close"]');
  const filterCount = root.querySelector('[data-role="filter-count"]');
  const guidedCollectionCards = root.querySelectorAll('[data-ccm-collection-preset]');
  const guidedPresets = {
    luxury:{ buyer:'Luxury', sort:'featured' },
    range:{ rangeMin:'700', sort:'rangeDesc' },
    family:{ buyer:'Family', body:'SUV', sort:'featured' },
    performance:{ buyer:'Performance', sort:'featured' },
    value:{ priceStatus:'Priced', sort:'priceAsc' }
  };
  let searchTrackingTimer = null;

  function browseResultsCount(){
    return Number(count?.textContent || 0);
  }
  function trackBrowse(eventName, parameters = {}){
    if (typeof window.CCMTrackEvent !== 'function') return;
    window.CCMTrackEvent(eventName, {
      interaction_context:'browse_page',
      results_count:browseResultsCount(),
      ...parameters
    });
  }
  function trackBrowseFilter(filterName, filterValue){
    trackBrowse('ccm_browse_filter_apply', {
      filter_name:filterName,
      filter_value:String(filterValue || 'All').slice(0, 100)
    });
  }
  function scheduleSearchTracking(){
    window.clearTimeout(searchTrackingTimer);
    searchTrackingTimer = window.setTimeout(() => {
      trackBrowse('ccm_browse_search', {
        search_length:state.search.trim().length,
        has_search_query:Boolean(state.search.trim())
      });
    }, 600);
  }

  function smartTitle(model){
    const parts = String(model || '').trim().split(/\s+/);
    if (parts.length <= 1) return `<span>${escapeHtml(model)}</span>`;
    return `<span>${escapeHtml(parts[0])}</span> <strong class="model-strong">${escapeHtml(parts.slice(1).join(' '))}</strong>`;
  }
  function shortPowertrain(value){
    const text = String(value || '').toLowerCase();
    if (text.includes('plug') || text.includes('phev')) return 'PHEV';
    if (text.includes('extended') || text.includes('erev')) return 'EREV';
    if (text.includes('electric') || text === 'ev') return 'EV';
    if (text.includes('petrol') || text.includes('gasoline')) return 'Petrol';
    return value || 'Vehicle';
  }
  function titleCaseTag(value){
    return String(value || '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
  function isDisplayTag(value){
    const tag = String(value || '').toLowerCase();
    return tag &&
      !tag.includes('draft') &&
      !tag.includes('price-to-confirm') &&
      !tag.includes('new-catalog') &&
      !tag.includes('china import') &&
      tag.length <= 24;
  }
  function priceDisplay(product){
    const raw = String(product.priceLabel || '').trim();
    if (!product.price || /^(tbd|price to confirm|price on request)$/i.test(raw)) return 'Price on request';
    return formatBrowseAmount(product.price);
  }
  function bodyLabel(value){
    const text = String(value || '').toLowerCase();
    if (text.includes('pickup')) return 'Pickup';
    if (text.includes('mpv')) return 'MPV';
    if (text.includes('wagon')) return 'Wagon';
    if (text.includes('sedan') || text.includes('fastback')) return 'Sedan';
    if (text.includes('suv') || text.includes('crossover')) return 'SUV';
    if (text.includes('coupe')) return 'Coupe';
    return 'Vehicle';
  }
  function compactSpec(value, type){
    const raw = String(value || '').trim();
    const text = raw.toLowerCase();
    if (!raw || ['ask','tbd','n/a','na','0'].includes(text)) return 'TBD';
    if (/(confirm|dependent|varies|market|by trim|selected trim|source dependent|to be confirmed)/i.test(raw)) {
      const numeric = extractNumericSpec(raw, type);
      return numeric || 'TBD';
    }
    const numeric = extractNumericSpec(raw, type);
    if (numeric) return numeric;
    if (type === 'range'){
      const powertrain = shortPowertrain(raw);
      return powertrain && powertrain !== 'Vehicle' ? powertrain : 'TBD';
    }
    return 'TBD';
  }
  function extractNumericSpec(raw, type){
    const value = String(raw || '');
    if (type === 'range'){
      const matches = [...value.matchAll(/([\d,.]+)\s*(?:km|kilometres|kilometers)/gi)]
        .map((match) => Number(match[1].replace(/,/g,'')))
        .filter(Boolean);
      if (matches.length) return `${Math.max(...matches).toLocaleString('en-US')} km`;
      if (/erev|phev|hybrid/i.test(value)) return shortPowertrain(value);
      return '';
    }
    if (type === 'power'){
      const match = value.match(/([\d,.]+)\s*(hp|kw|kW|ps)/i);
      return match ? `${Number(match[1].replace(/,/g,'')).toLocaleString('en-US')} ${match[2].toLowerCase() === 'kw' ? 'kW' : match[2].toLowerCase()}` : '';
    }
    if (type === 'zero'){
      const match = value.match(/([\d.]+)\s*(?:s|sec|seconds)/i);
      return match ? `${match[1]} s` : '';
    }
    return '';
  }
  function missingSpec(value){
    const text = String(value || '').trim().toLowerCase();
    return !text || ['ask','tbd','n/a','na','0','—','-'].includes(text) || /(confirm|dependent|varies|market\/trim|by trim|selected trim|source dependent|to be confirmed)/i.test(text);
  }
  function adaptiveMetrics(product){
    const ptRaw = String(product.powertrain || '');
    const pt = ptRaw.toLowerCase();
    const shortPt = shortPowertrain(ptRaw);
    const iceLike =
      ((pt.includes('petrol') || pt.includes('gasoline') || pt.includes('diesel')) &&
       !/(plug|phev|erev|extended|electric)/i.test(pt)) ||
      (pt.includes('hybrid') && !/(plug|phev|erev|extended)/i.test(pt));

    const range = compactSpec(product.range, 'range');
    const power = compactSpec(product.power, 'power');
    const zero = compactSpec(product.zero, 'zero');
    const torque = missingSpec(product.torque) ? '' : String(product.torque);
    const economy = missingSpec(product.economy) ? '' : String(product.economy);
    const drive = missingSpec(product.drive) ? '' : String(product.drive);
    const engine = missingSpec(product.engine) ? '' : String(product.engine);

    let one = {label:'Range', value:range, title:product.range};
    if (iceLike || missingSpec(range)) {
      if (economy) one = {label:'Fuel economy', value:economy, title:economy};
      else one = {label:'Powertrain', value:shortPt, title:ptRaw};
    }

    let two = {label:'Power', value:power, title:product.power};
    if (missingSpec(power)) {
      if (torque) two = {label:'Torque', value:torque, title:torque};
      else if (drive) two = {label:'Drive', value:drive, title:drive};
      else two = {label:'Powertrain', value:shortPt, title:ptRaw};
    }

    let three = {label:'0-100', value:zero, title:product.zero};
    if (missingSpec(zero)) {
      if (torque && two.label !== 'Torque') three = {label:'Torque', value:torque, title:torque};
      else if (drive && two.label !== 'Drive') three = {label:'Drive', value:drive, title:drive};
      else if (engine) three = {label:'Engine', value:engine, title:engine};
      else three = {label:'Powertrain', value:shortPt, title:ptRaw};
    }
    return [one,two,three];
  }
  function escapeHtml(value){
    return String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  }
  function matchesBuyer(product){
    if (state.buyer === 'All') return true;
    const haystack = [product.segment, product.note, ...product.features].join(' ').toLowerCase();
    return haystack.includes(state.buyer.toLowerCase());
  }
  function matchesBuyerCard(card){
    if (state.buyer === 'All') return true;
    const wanted = state.buyer.toLowerCase();
    const haystack = [card.dataset.search, card.dataset.tags, card.dataset.segment].join(' ').toLowerCase();
    if (wanted === 'off-road') return /(off.?road|rugged|adventure|4x4|awd|terrain)/i.test(haystack);
    return haystack.includes(wanted);
  }
  function normalizedPowertrainMatch(raw, wanted){
    if (wanted === 'All') return true;
    const text = String(raw || '').toLowerCase();
    const value = wanted.toLowerCase();
    if (value === 'ev') return text === 'ev' || (text.includes('electric') && !text.includes('hybrid') && !text.includes('extended') && !text.includes('erev') && !text.includes('phev'));
    if (value === 'phev') return text.includes('phev') || text.includes('plug');
    if (value === 'erev') return text.includes('erev') || text.includes('extended') || text.includes('range extender');
    if (value === 'hybrid') return text.includes('hybrid') || text.includes('dm-i') || text.includes('dmi');
    if (value === 'petrol') return text.includes('petrol') || text.includes('gasoline') || text.includes('ice');
    return text.includes(value);
  }
  function normalizedBodyMatch(raw, wanted){
    if (wanted === 'All') return true;
    return bodyLabel(raw).toLowerCase() === wanted.toLowerCase() || String(raw || '').toLowerCase().includes(wanted.toLowerCase());
  }
  function numericRangeValue(value){
    const matches = [...String(value || '').replace(/,/g, '').matchAll(/([\d.]+)\s*(?:km|kilometres|kilometers)?/gi)]
      .map((match) => Number(match[1]))
      .filter((number) => Number.isFinite(number) && number > 100);
    return matches.length ? Math.max(...matches) : 0;
  }
  function matchesRangeCard(card){
    if (state.rangeMin === 'All') return true;
    const range = numericRangeValue(card.dataset.rangeRaw);
    return range >= Number(state.rangeMin);
  }
  function matchesPriceStatusCard(card){
    if (state.priceStatus === 'All') return true;
    const status = String(card.dataset.priceStatus || '').toLowerCase();
    return state.priceStatus === 'Priced' ? status === 'priced' : status === 'request';
  }
  function matchesDriveCard(card){
    if (state.drive === 'All') return true;
    const haystack = [card.dataset.search, card.dataset.tags, card.dataset.segment].join(' ').toLowerCase();
    const drive = state.drive.toLowerCase();
    if (drive === 'awd') return /\bawd\b|all.?wheel|four.?wheel|4wd/i.test(haystack);
    if (drive === '4wd') return /\b4wd\b|four.?wheel|off.?road|terrain/i.test(haystack);
    if (drive === 'rwd') return /\brwd\b|rear.?wheel/i.test(haystack);
    if (drive === 'fwd') return /\bfwd\b|front.?wheel/i.test(haystack);
    return haystack.includes(drive);
  }
  function matchesFeatureCard(card){
    if (state.feature === 'All') return true;
    const haystack = [card.dataset.search, card.dataset.tags, card.dataset.rangeRaw, card.dataset.powerRaw].join(' ').toLowerCase();
    const feature = state.feature.toLowerCase();
    const signals = {
      adas: /(adas|assist|driver|safety|autonomous|lidar|radar)/i,
      cabin: /(cabin|seat|interior|comfort|screen|cockpit|display|panoramic)/i,
      audio: /(audio|sound|speaker|naim|dynaudio|meridian|dolby)/i,
      warranty: /(warranty|service|after.?sales|dealer)/i,
      import: /(import|china.?market|uae|gcc|grey|gray)/i,
      'automatic doors': /(automatic.?doors|power.?doors|soft.?close)/i,
      'rear entertainment': /(rear.?entertainment|rear.?screen|second.?row.?screen|passenger.?screen)/i,
      'flat bed': /(flat.?bed|lie.?flat|reclining|zero.?gravity)/i,
      projector: /(projector|headlight|laser.?light|matrix.?light)/i,
      panoramic: /(panoramic|sunroof|glass.?roof)/i,
      electrochromatic: /(electrochromatic|dimming|smart.?glass)/i,
      'ai voice': /(ai.?voice|voice.?assistant|assistant|smart.?cockpit)/i
    };
    return signals[feature] ? signals[feature].test(haystack) : haystack.includes(feature);
  }
  function productCard(product){
    const displayTags = product.features.filter(isDisplayTag).slice(0, 4);
    const tags = displayTags.map((feature) => `<span class="ccm-mini-tag">${escapeHtml(titleCaseTag(feature))}</span>`).join('');
    const displayPrice = priceDisplay(product);
    const metrics = adaptiveMetrics(product);
    const displayBody = bodyLabel(product.body);
    const displaySegment = bodyLabel(product.segment) === 'Vehicle' ? product.segment : bodyLabel(product.segment);
    const displayBadge = isDisplayTag(product.badge) ? titleCaseTag(product.badge) : 'Available';
    return `
      <article class="ccm-card" data-brand="${escapeHtml(product.brand)}" data-body="${escapeHtml(product.body)}" data-powertrain="${escapeHtml(product.powertrain)}" data-price="${product.price}">
        <a class="image-wrap" href="${escapeHtml(product.url)}">
          <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.model)}" loading="lazy">
          <div class="ccm-badges"><span class="ccm-pill gold">${escapeHtml(displayBadge || 'Available')}</span><span class="ccm-pill">${escapeHtml(shortPowertrain(product.powertrain))}</span></div>
        </a>
        <div class="ccm-card-body">
          <div class="ccm-brand-line"><span>${escapeHtml(product.brand)}</span><span>${escapeHtml(displaySegment)}</span></div>
          <h3>${smartTitle(product.model)}</h3>
          <p>${escapeHtml(product.note || 'Indicative vehicle profile. Confirm final trim, warranty and availability before purchase.')}</p>
          <div class="ccm-card-meta">
            <div class="ccm-price-tile">
              <small>${displayPrice === 'Price on request' ? 'Price' : escapeHtml(ACTIVE_CURRENCY)}</small>
              <b>${escapeHtml(displayPrice)}</b>
              <span>${displayPrice === 'Price on request' ? 'Request a quote for current pricing' : 'Indicative reference price'}</span>
            </div>
            <div class="ccm-specs">
              <div class="ccm-spec"><span>${escapeHtml(metrics[0].label)}</span><b title="${escapeHtml(metrics[0].title)}">${escapeHtml(metrics[0].value)}</b></div>
              <div class="ccm-spec"><span>${escapeHtml(metrics[1].label)}</span><b title="${escapeHtml(metrics[1].title)}">${escapeHtml(metrics[1].value)}</b></div>
              <div class="ccm-spec"><span>${escapeHtml(metrics[2].label)}</span><b title="${escapeHtml(metrics[2].title)}">${escapeHtml(metrics[2].value)}</b></div>
              <div class="ccm-spec"><span>Body style</span><b title="${escapeHtml(product.body)}">${escapeHtml(displayBody)}</b></div>
            </div>
          </div>
          <div class="ccm-feature-tags">${tags}</div>
          <div class="ccm-actions">
            <a class="ccm-btn primary" href="${escapeHtml(product.url)}">View product</a>
            <button class="ccm-compare" type="button" data-compare-product="${escapeHtml(product.id)}">Compare</button>
          </div>
        </div>
      </article>`;
  }
  function setCardVisibility(card, isVisible){
    card.toggleAttribute('hidden', !isVisible);
    card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    card.classList.toggle('is-filtered-out', !isVisible);
    card.dataset.visible = isVisible ? 'true' : 'false';
    if (isVisible) {
      card.style.removeProperty('display');
      card.style.removeProperty('visibility');
      card.style.removeProperty('opacity');
      return;
    }
    card.style.setProperty('display', 'none', 'important');
    card.style.setProperty('visibility', 'hidden', 'important');
    card.style.setProperty('opacity', '0', 'important');
  }
  function setChipValue(key, value){
    state[key] = value;
    root.querySelectorAll(`[data-filter="${key}"]`).forEach((item) => {
      const isActive = item.dataset.value === value;
      item.classList.toggle('active', isActive);
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
  function setGuidedActive(name){
    guidedCollectionCards.forEach((card) => {
      const isActive = card.dataset.ccmCollectionPreset === name;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
  function applyGuidedPreset(name, shouldScroll){
    const preset = guidedPresets[name];
    if (!preset) return false;
    resetFilters(false);
    Object.entries(preset).forEach(([key, value]) => {
      if (key === 'sort') {
        state.sort = value;
        if (sort) sort.value = value;
        return;
      }
      if (key === 'brand') {
        state.brand = value;
        if (brandFilter) brandFilter.value = value;
        return;
      }
      if (key === 'budget') {
        state.budget = Number(value);
        if (budget) budget.value = state.budget;
        if (budgetLabel) budgetLabel.textContent = formatMarketCurrency(state.budget);
        return;
      }
      setChipValue(key, value);
    });
    setGuidedActive(name);
    render();
    if (shouldScroll) {
      document.getElementById('browse-vehicles')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const url = new URL(window.location.href);
      url.searchParams.set('collection', name);
      url.hash = 'browse-vehicles';
      window.history.replaceState({}, '', url);
    }
    return true;
  }
  function render(){
    const query = state.search.toLowerCase().trim();
    const sortedCards = [...cards].sort((a,b) => {
      const aPrice = Number(a.dataset.price || 0);
      const bPrice = Number(b.dataset.price || 0);
      const aRange = numericRangeValue(a.dataset.rangeRaw);
      const bRange = numericRangeValue(b.dataset.rangeRaw);
      const aOrder = Number(a.dataset.order || 0);
      const bOrder = Number(b.dataset.order || 0);
      if (state.sort === 'priceAsc') return (aPrice <= 0) - (bPrice <= 0) || aPrice - bPrice || aOrder - bOrder;
      if (state.sort === 'priceDesc') return (aPrice <= 0) - (bPrice <= 0) || bPrice - aPrice || aOrder - bOrder;
      if (state.sort === 'rangeDesc') return bRange - aRange || aOrder - bOrder;
      return aOrder - bOrder;
    });
    let visibleCount = 0;
    sortedCards.forEach((card) => {
      const cardPrice = Number(card.dataset.price || 0);
      const cardBrand = String(card.dataset.brand || '');
      const cardSearch = String(card.dataset.search || '').toLowerCase();
      const searchOk = !query || cardSearch.includes(query);
      const isVisible = searchOk &&
        (state.brand === 'All' || cardBrand === state.brand) &&
        normalizedBodyMatch(card.dataset.body, state.body) &&
        normalizedPowertrainMatch(card.dataset.powertrain, state.powertrain) &&
        (!state.budget || cardPrice <= state.budget || cardPrice === 0) &&
        matchesRangeCard(card) &&
        matchesPriceStatusCard(card) &&
        matchesDriveCard(card) &&
        matchesBuyerCard(card) &&
        matchesFeatureCard(card);
      if (isVisible) visibleCount += 1;
      grid.appendChild(card);
      setCardVisibility(card, isVisible);
    });
    count.textContent = visibleCount;
    if (filterCount) filterCount.textContent = visibleCount;
    empty.style.display = visibleCount ? 'none' : 'block';
  }

  function matchingProducts(){
    const query = state.search.toLowerCase().trim();
    return products.filter((product) => {
      const searchOk = !query || [product.brand, product.model, product.segment, product.note, ...product.features].join(' ').toLowerCase().includes(query);
      return searchOk &&
        (state.body === 'All' || product.body.toLowerCase().includes(state.body.toLowerCase())) &&
        (state.powertrain === 'All' || product.powertrain.toLowerCase().includes(state.powertrain.toLowerCase())) &&
        (!state.budget || product.price <= state.budget || product.price === 0) &&
        matchesBuyer(product);
    });
  }

  function firstNumber(value){
    const match = String(value || '').replace(/,/g, '').match(/[\d.]+/);
    return match ? Number(match[0]) : null;
  }
  function horsepowerValue(value){
    const number = firstNumber(value);
    if (!number) return null;
    return /\bkw\b/i.test(String(value)) ? Math.round(number * 1.34102) : Math.round(number);
  }
  function compareVehicleFromProduct(product){
    const brand = String(product.brand || '').trim();
    let model = String(product.model || 'Vehicle').trim();
    if (brand && model.toLowerCase().startsWith(brand.toLowerCase())) model = model.slice(brand.length).trim() || model;
    const meaningfulFeatures = product.features.filter(isDisplayTag);
    return {
      id:`product-${product.handle || product.id}`,
      productId:product.id,
      handle:product.handle || '',
      url:new URL(product.url, window.location.origin).href,
      source:'ChinaCarMart store',
      brand:brand || 'ChinaCarMart',
      model,
      body_style:bodyLabel(product.body),
      powertrain:shortPowertrain(product.powertrain),
      price_aed:product.basePriceAed || product.price || null,
      price_display:product.priceLabel || '',
      power_hp:horsepowerValue(product.power),
      zero_to_100_sec:firstNumber(product.zero),
      range:product.range || 'Not listed',
      range_km:firstNumber(product.range),
      engine_battery:product.battery || product.powertrain || 'Not listed',
      adas:meaningfulFeatures.find((item) => /adas|assist|safety/i.test(item)) || 'Trim dependent',
      audio:meaningfulFeatures.find((item) => /audio|sound|speaker/i.test(item)) || 'Trim dependent',
      screen:meaningfulFeatures.find((item) => /screen|display|cockpit|infotainment/i.test(item)) || 'Trim dependent',
      warranty:product.warranty || 'Market dependent',
      image:product.image || '',
      availability:'Store vehicle',
      source_quality:'Live Shopify product'
    };
  }
  grid?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-compare-product]');
    if (!button) return;
    const product = products.find((item) => String(item.id) === String(button.dataset.compareProduct));
    if (!product) return;
    if (window.CCMCompareState) window.CCMCompareState.navigate(compareVehicleFromProduct(product));
    else window.location.assign('/pages/compare');
  });

  function populateBrandFilter(){
    if (!brandFilter) return;
    const brands = [...new Set(cards.map((card) => String(card.dataset.brand || '').trim()).filter(Boolean))].sort((a,b) => a.localeCompare(b));
    brandFilter.innerHTML = '<option value="All">All brands</option>' + brands.map((brand) => `<option value="${escapeHtml(brand)}">${escapeHtml(brand)}</option>`).join('');
  }

  root.querySelectorAll('[data-filter]').forEach((chip) => {
    chip.addEventListener('click', () => {
      const key = chip.dataset.filter;
      if (!key) return;
      state[key] = chip.dataset.value;
      root.querySelectorAll(`[data-filter="${key}"]`).forEach((item) => {
        item.classList.remove('active', 'is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('active');
      chip.classList.add('is-active');
      chip.setAttribute('aria-pressed', 'true');
      render();
      trackBrowseFilter(key, chip.dataset.value);
    });
  });
  brandFilter?.addEventListener('change', (event) => {
    state.brand = event.target.value || 'All';
    render();
    trackBrowseFilter('brand', state.brand);
  });
  search?.addEventListener('input', (event) => {
    state.search = event.target.value;
    if (mobileSearch && mobileSearch.value !== state.search) mobileSearch.value = state.search;
    render();
    scheduleSearchTracking();
  });
  mobileSearch?.addEventListener('input', (event) => {
    state.search = event.target.value;
    if (search && search.value !== state.search) search.value = state.search;
    render();
    scheduleSearchTracking();
  });
  budget?.addEventListener('input', (event) => {
    state.budget = Number(event.target.value);
    budgetLabel.textContent = formatMarketCurrency(state.budget);
    render();
  });
  budget?.addEventListener('change', () => {
    trackBrowseFilter('budget_max', state.budget);
  });
  sort?.addEventListener('change', (event) => {
    state.sort = event.target.value;
    render();
    trackBrowseFilter('sort', state.sort);
  });
  function resetFilters(shouldRender = true){
    state.brand = 'All';
    state.body = 'All';
    state.powertrain = 'All';
    state.drive = 'All';
    state.buyer = 'All';
    state.rangeMin = 'All';
    state.priceStatus = 'All';
    state.feature = 'All';
    state.budget = Number(budget?.max || config.budgetCeiling);
    state.search = '';
    state.sort = 'featured';
    if (search) search.value = '';
    if (mobileSearch) mobileSearch.value = '';
    if (budget) budget.value = state.budget;
    if (budgetLabel) budgetLabel.textContent = formatMarketCurrency(state.budget);
    if (sort) sort.value = 'featured';
    if (brandFilter) brandFilter.value = 'All';
    root.querySelectorAll('[data-filter]').forEach((item) => {
      item.classList.remove('active', 'is-active');
      item.setAttribute('aria-pressed', 'false');
    });
    root.querySelectorAll('[data-filter][data-value="All"]').forEach((item) => {
      item.classList.add('active', 'is-active');
      item.setAttribute('aria-pressed', 'true');
    });
    setGuidedActive('');
    if (shouldRender) render();
  }
  resetButtons.forEach((button) => button.addEventListener('click', () => {
    resetFilters();
    trackBrowse('ccm_browse_filter_reset');
  }));
  function setFilterOpen(open){
    if (!filter) return;
    if (open) {
      filter.hidden = false;
      window.requestAnimationFrame(() => {
        filter.classList.add('is-open');
        filterToggle?.setAttribute('aria-expanded', 'true');
        if (filterToggleLabel) filterToggleLabel.textContent = 'Hide filters';
      });
      return;
    }
    filter.classList.remove('is-open');
    filterToggle?.setAttribute('aria-expanded', 'false');
    if (filterToggleLabel) filterToggleLabel.textContent = 'Refine search';
    window.setTimeout(() => {
      if (!filter.classList.contains('is-open')) filter.hidden = true;
    }, 640);
  }
  filterToggle?.addEventListener('click', () => {
    const isOpen = !(filter?.classList.contains('is-open'));
    setFilterOpen(isOpen);
    trackBrowse('ccm_browse_filter_panel', { panel_action:isOpen ? 'open' : 'close' });
  });
  filterCloseButtons.forEach((button) => button.addEventListener('click', () => {
    setFilterOpen(false);
  }));
  root.querySelectorAll('[data-role="filter-collapse"]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-ccm-filter-group]');
      const collapsed = !group?.classList.contains('is-collapsed');
      group?.classList.toggle('is-collapsed', collapsed);
      button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });
  filter?.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setFilterOpen(false);
  });

  const editorialRevealBtn = document.getElementById('editorialRevealBtn-' + config.sectionId + '');
  const editorialShowcase = document.getElementById('editorialShowcase-' + config.sectionId + '');
  editorialRevealBtn?.addEventListener('click', () => {
    const expanded = editorialShowcase.classList.toggle('is-expanded');
    editorialRevealBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    editorialRevealBtn.querySelector('.ccm-editorial-reveal-text').textContent = expanded ? 'Show fewer editorial cards' : 'See more editorial cards';
    trackBrowse('ccm_browse_editorial_toggle', { panel_action:expanded ? 'expand' : 'collapse' });
  });
  guidedCollectionCards.forEach((card) => {
    card.addEventListener('click', (event) => {
      if (applyGuidedPreset(card.dataset.ccmCollectionPreset, true)) {
        event.preventDefault();
        trackBrowse('ccm_browse_collection_preset', { preset_name:card.dataset.ccmCollectionPreset });
      }
    });
  });
  populateBrandFilter();
  const initialCollection = new URLSearchParams(window.location.search).get('collection');
  if (!initialCollection || !applyGuidedPreset(initialCollection, false)) render();
  window.setTimeout(() => {
    trackBrowse('ccm_browse_results_view', {
      preset_name:initialCollection || 'all',
      total_products:cards.length
    });
  }, 0);

  });
})();
